export function OutlineProyectoIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29848_88212)">
        <path
          d="M16.354 0.748047V4.65413C16.354 4.95642 16.597 5.19944 16.8993 5.19944H20.7817"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          d="M20.7819 22.0271V5.03355C20.7819 4.71347 20.6574 4.39933 20.4262 4.16816L17.4152 1.10968C17.184 0.872588 16.8699 0.742188 16.5379 0.742188H4.22695C3.54531 0.742188 3 1.29343 3 1.96914V22.0152C3 22.6969 3.55124 23.2422 4.22695 23.2422H19.549C20.2306 23.2422 20.7759 22.6909 20.7759 22.0152L20.7819 22.0271Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
        <path
          d="M5.96362 4.60742H13.3727"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M8.91548 17.913C9.73715 17.913 10.4032 17.2469 10.4032 16.4253C10.4032 15.6036 9.73715 14.9375 8.91548 14.9375C8.09382 14.9375 7.42773 15.6036 7.42773 16.4253C7.42773 17.2469 8.09382 17.913 8.91548 17.913Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3186 9.05859C16.3304 10.0485 16.3364 11.0324 16.3482 12.0222C16.366 12.3127 16.4134 13.8182 15.2754 15.0689C13.9536 16.5211 12.128 16.4321 11.8909 16.4203C11.393 16.4203 10.8951 16.4203 10.3972 16.4203"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.40161 9.4375L11.4939 11.5298"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.482 9.4375L9.38965 11.5298"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_29848_88212">
          <rect width={width} height={height} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
}
